import { Injector } from "@angular/core";
import { ServiceEnum } from "../../../ServiceEnum";
import { ScientificProductsEntity } from "../../../Data/MedicinalProductData/ScientificProductsEntity";
import { EntityEnum } from "../../EntityEnum";
import { AbstractPharmaceuticalProductsFormulationAutoUploadEntity } from "./AbstractPharmaceuticalProductsFormulationAutoUploadEntity";
import { DummyNode } from "../../DummyNode";
import { OnDemandAutoUploadList } from "../ListEntity/OnDemandAutouploadList";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";


export class AbstractPharmaceuticalProductsFormulationAutoUploadList extends OnDemandAutoUploadList {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, searchCriteriaId: string, useHist: boolean, disableAutoupload: boolean, cloningNode: boolean) {
        super(injector, 
            labelTemplate,
            ['Scientific Name','Scientific Code','Scientific Strength','Scientific Pharmaceutical Form Name','Owner HQ ID', 'Type', 'Status', 'Nullified'],
            ServiceEnum.MedicinalProducts,
            `abspharmprodformulation:eq:${searchCriteriaId}`,
            ScientificProductsEntity,
            EntityEnum.abstractPharmaceuticalProductsFormulation,
            disableAutoupload,
            cloningNode 
            );
            this.useHist = useHist;
            
            if (this.cloningNode) {
                return;
             }

             this.children?.push(new DummyNode());
    }

    override filterResult(model:any): any{
        const uniqueBySciProd = model.filter((item: any, index: number, self:any) =>
        index === self.findIndex((t: any) => t.id === item.id)
        );
        return uniqueBySciProd;        
    }

    override postLoad(model: any[]) {

        for (const item of model) { 
            this.children?.push(new AbstractPharmaceuticalProductsFormulationAutoUploadEntity(this.ioc!, `${item.scientificname}`,this,item,this.useHist,true, false));
        }
        const numItems: string = model && model.length > 0?model.length.toString():'0'; 
        this.label = this.labelTemplate + ' (' + numItems + ')';
        this.refreshLabel();
    }

    override getOnDemandEntities() { 
        if (!this.isLoaded) {
            return {};
        }
        
        const entitiesArray:any[] = [];
        this.children?.forEach(child=>{
            const onDemandEntities: any = (child as OnDemandAutoUploadNode).getOnDemandEntities();
            entitiesArray.push(onDemandEntities);
        });
        return {abstractpharmaceuticalproducts: {abstractpharmaceuticalproduct: entitiesArray}};
    }

}